
/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Transformar la fecha enviada en formato largo, ej: "10 de Mayo del 2019, 4:50 p.m."
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     1/Oct/2019
 *
*/
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateLong'
})
export class DateLongPipe implements PipeTransform {

  transform(value: any): string {
    try {
      var fecha = new Date(value);

      var fechaLarga: string = new DatePipe('es').transform(fecha, 'longDate');
      var Hora: string = new DatePipe('es').transform(fecha, 'hh:mm a')
  
      return fechaLarga + ", " + Hora;
    } catch {
      console.log("fecha no válida " + value + "debe ser: MM/dd/yyyy hh:mm");
      return value;
    }
  }
}
